/* eslint-disable import/prefer-default-export,no-param-reassign */

// Render a template string with the provided data. For each key k in data, every
// occurrence of "{{ k }}" in template will be replaced with data[k].
//
// It would be nice if the server did this, but since we retrieve email templates
// independent of calendar events, the server has no knowledge of which calendar
// event you are writing an email for.
export const render = (template = '', data = {}) => {
  Object.keys(data).forEach((key) => {
    const re = new RegExp(`{{\\s*${key}\\s*}}`, 'gi');
    template = template.replace(re, data[key]);
  });
  return template;
};

export const highlightTemplateStrings = (content) => {
  if (content !== undefined) {
    const templateRegex = /\[(.*?)\]/g;
    return content.replaceAll(templateRegex, match => `<font color="red">${match}</font>`);
  }
  return content;
};
